import { Link } from "react-router-dom";

import LegimetrieSM from "../../assets/img/legimetrie-sm.png";
import Legimetrie from "../../assets/img/legimetrie.png";

type DwellLogoProps = {
  linkTo: string;
  size?: "md" | "sm";
  logoUrl?: string;
};
const DwellLogo = (props: DwellLogoProps) => {
  return (
    <Link to={props.linkTo}>
      {props.size === "sm" ? (
        <img src={props.logoUrl || LegimetrieSM} alt="group-logo" width="50" height="50" />
      ) : (
        <img src={props.logoUrl || Legimetrie} alt="group-logo" width="160" height="77" />
      )}
    </Link>
  );
};
export default DwellLogo;
